/* eslint-disable */
import settings from "../../../configs/settings";
import { v4 as uuidv4 } from "uuid";
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/system";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useContext, useState } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import BuscarTratamientoDialog from "./BuscarTratamientoDialog";
import { getTratamiento } from "../../../project/services/TratamientoService";
import { getPorcentajeDescuento } from "../../../project/services/ArticuloService";
import Message from "../../../project/utils/Message";
import { formatMoney } from "../../utils/utils"
import { limpiaCodigo } from "../../utils/utils";
import WaitingDialog from "../../utils/WaitingDialog";

//
// ################################################################################
//
const ArregloTratamientos = () => {
  const [openDialogBusquedaAvanzada, setOpenDialogBusquedaAvanzada] = useState(false);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const {
    arregloTratamientosOjoOptions,
    initialArregloTratamiento,
    arregloTratamiento,
    handleChangeArregloTratamiento,
    setArregloTratamiento,
    arregloTratamientosRows,
    setArregloTratamientosRows,
    totalArregloTratamientos,
    totalArregloTratamientosContado,
    gaAction,
  } = useContext(GestionAtencionContext);
  let {
    arregloTratamientoOjo,
    arregloTratamientoCodigo,
    arregloTratamientoDescripcion,
    arregloTratamientoPrecioVenta,
    arregloTratamientoPorcentajeDescuento,
    arregloTratamientoPrecioVentaContado,
  } = arregloTratamiento;
  const [disabledTratamientos, setDisabledTratamientos] = useState(false);
  const [ojoValidOptions, setOjoValidOptions] = useState(arregloTratamientosOjoOptions);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);

  const tableColumns = [
    {
      field: "arregloTratamientoOjo",
      headerName: "Ojo",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloTratamientoOjo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "arregloTratamientoCodigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloTratamientoCodigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "arregloTratamientoDescripcion",
      headerName: "Tratamiento",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloTratamientoDescripcion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "arregloTratamientoPrecioVenta",
      headerName: "Prc Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloTratamientoPrecioVenta.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "arregloTratamientoPrecioVentaContado",
      headerName: "Prc Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloTratamientoPrecioVentaContado.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {gaAction.cu !== "view" && (
            <Tooltip title="quitar tratamiento">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleClickActionTratamiento(params.row)}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  const handleClickActionTratamiento = (parRow) => {
    if (parRow === undefined) {
      // si estoy agregando un tratamiento

      let _tratamientoRepetido = false;
      arregloTratamientosRows.forEach((item) => {
        if (
          item.arregloTratamientoOjo === arregloTratamiento.arregloTratamientoOjo &&
          item.arregloTratamientoCodigo === arregloTratamiento.arregloTratamientoCodigo
        ) {
          _tratamientoRepetido = true;
        }
      });

      if (_tratamientoRepetido) {
        setMessage({
          messageText: "Ya agregaste este tratamiento para el ojo seleccionado",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      if (arregloTratamiento.arregloTratamientoOjo === "ambos") {
        // si el vendedor selecciono el tratatamiento para ambos ojos

        let _arregloTratamientosRowsTmp = [];
        if (
          !arregloTratamientosRows.some(
            (item) =>
              item.arregloTratamientoOjo === "izquierdo" &&
              item.arregloTratamientoCodigo === arregloTratamiento.arregloTratamientoCodigo
          )
        ) {
          // si el tratamiento no esta agregado para el ojo derecho, lo agrego

          let _tratamientoOjoIzquierdo = {
            id: uuidv4(),
            arregloTratamientoId: arregloTratamiento.arregloTratamientoId,
            arregloTratamientoOjo: "izquierdo",
            arregloTratamientoCodigo: arregloTratamiento.arregloTratamientoCodigo,
            arregloTratamientoDescripcion: arregloTratamiento.arregloTratamientoDescripcion,
            arregloTratamientoPrecioVenta: arregloTratamiento.arregloTratamientoPrecioVenta,
            arregloTratamientoPrecioVentaOriginal:
              arregloTratamiento.arregloTratamientoPrecioVentaOriginal,
            arregloTratamientoPorcentajeDescuento:
              arregloTratamiento.arregloTratamientoPorcentajeDescuento,
            arregloTratamientoPrecioVentaContado:
              arregloTratamiento.arregloTratamientoPrecioVentaContado,
          };
          _arregloTratamientosRowsTmp.push(_tratamientoOjoIzquierdo);
        }

        if (
          !arregloTratamientosRows.some(
            (item) =>
              item.arregloTratamientoOjo === "derecho" &&
              item.arregloTratamientoCodigo === arregloTratamiento.arregloTratamientoCodigo
          )
        ) {
          // si el tratamiento no esta agregado para el ojo derecho, lo agrego

          let _tratamientoOjoDerecho = {
            id: uuidv4(),
            arregloTratamientoId: arregloTratamiento.arregloTratamientoId,
            arregloTratamientoOjo: "derecho",
            arregloTratamientoCodigo: arregloTratamiento.arregloTratamientoCodigo,
            arregloTratamientoDescripcion: arregloTratamiento.arregloTratamientoDescripcion,
            arregloTratamientoPrecioVenta: arregloTratamiento.arregloTratamientoPrecioVenta,
            arregloTratamientoPrecioVentaOriginal:
              arregloTratamiento.arregloTratamientoPrecioVentaOriginal,
            arregloTratamientoPorcentajeDescuento:
              arregloTratamiento.arregloTratamientoPorcentajeDescuento,
            arregloTratamientoPrecioVentaContado:
              arregloTratamiento.arregloTratamientoPrecioVentaContado,
          };
          _arregloTratamientosRowsTmp.push(_tratamientoOjoDerecho);
        }
        setArregloTratamientosRows([...arregloTratamientosRows, ..._arregloTratamientosRowsTmp]);
      } else {
        // si el vendedor selecciono el tratatamiento para ojo izquierdo o para ojo derecho
        let _tratamiento = {
          id: uuidv4(),
          arregloTratamientoId: arregloTratamiento.arregloTratamientoId,
          arregloTratamientoOjo: arregloTratamiento.arregloTratamientoOjo,
          arregloTratamientoCodigo: arregloTratamiento.arregloTratamientoCodigo,
          arregloTratamientoDescripcion: arregloTratamiento.arregloTratamientoDescripcion,
          arregloTratamientoPrecioVenta: arregloTratamiento.arregloTratamientoPrecioVenta,
          arregloTratamientoPrecioVentaOriginal:
            arregloTratamiento.arregloTratamientoPrecioVentaOriginal,
          arregloTratamientoPorcentajeDescuento:
            arregloTratamiento.arregloTratamientoPorcentajeDescuento,
          arregloTratamientoPrecioVentaContado:
            arregloTratamiento.arregloTratamientoPrecioVentaContado,
        };
        setArregloTratamientosRows([...arregloTratamientosRows, _tratamiento]);
      }
      setArregloTratamiento(initialArregloTratamiento);
    } else {
      // si estoy eliminando un tratamiento

      let _tratamientosRows = arregloTratamientosRows.filter(
        (item) => item.id !== parRow.id
      );
      setArregloTratamientosRows(_tratamientosRows);
    }
  };
  //
  // ################################################################################
  //
  const handleBuscarTratamiento = () => {
    if (arregloTratamientoCodigo === "") {
      return;
    }

    const buscarTratamiento = async () => {

      const _arregloTratamientoCodigo = limpiaCodigo(arregloTratamientoCodigo).toUpperCase();

      setArregloTratamiento({
        ...arregloTratamiento,
        arregloTratamientoCodigo: _arregloTratamientoCodigo,
      });

      setIsDoingSomething(true);
      const response = await getTratamiento(_arregloTratamientoCodigo);
      setIsDoingSomething(false);

      if (response.ok) {
        let _params = {
          tipoArticulo: "tratamiento",
          id: response.data.data[0].id_tr_marca,
        };

        setIsDoingSomething(true);
        const responseDescuento = await getPorcentajeDescuento(_params);
        setIsDoingSomething(false);

        let _porcentajeDescuento = 0;
        if (responseDescuento.ok) {
          _porcentajeDescuento = responseDescuento.data.data.porcentaje_descuento;
        }
        let _precioVentaContado =
          response.data.data[0].precio_venta_lista -
          (response.data.data[0].precio_venta_lista * _porcentajeDescuento) / 100;

        let _tratamiento = {
          arregloTratamientoId: response.data.data[0].id,
          arregloTratamientoOjo: arregloTratamientoOjo,
          arregloTratamientoCodigo: response.data.data[0].codigo,
          arregloTratamientoDescripcion: response.data.data[0].descripcion,
          arregloTratamientoPrecioVenta: response.data.data[0].precio_venta_lista,
          arregloTratamientoPrecioVentaOriginal: response.data.data[0].precio_venta_lista,
          arregloTratamientoPorcentajeDescuento: _porcentajeDescuento,
          arregloTratamientoPrecioVentaContado: _precioVentaContado,
        };
        setArregloTratamiento(_tratamiento);
      } else {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
        setArregloTratamiento(initialArregloTratamiento);
      }
    };

    buscarTratamiento();
  };
  //
  // ################################################################################
  //
  const handleClickOpenBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(true);
  };
  //
  // ################################################################################
  //
  const handleCloseBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(false);
  };
  //
  // ################################################################################
  //
  const handleSelectBusquedaAvanzada = async (articulo) => {
    setOpenDialogBusquedaAvanzada(false);

    let _params = {
      tipoArticulo: "tratamiento",
      id: articulo.id_tr_marca,
    };

    const response = await getPorcentajeDescuento(_params);
    let _porcentajeDescuento = 0;
    if (response.ok) {
      _porcentajeDescuento = response.data.data.porcentaje_descuento;
    }
    let _precioVentaContado =
      articulo.precio_venta_lista - (articulo.precio_venta_lista * _porcentajeDescuento) / 100;

    let _tratamiento = {
      arregloTratamientoId: articulo.id,
      arregloTratamientoOjo: arregloTratamientoOjo,
      arregloTratamientoCodigo: articulo.codigo,
      arregloTratamientoDescripcion: articulo.descripcion,
      arregloTratamientoPrecioVenta: articulo.precio_venta_lista,
      arregloTratamientoPrecioVentaOriginal: articulo.precio_venta_lista,
      arregloTratamientoPorcentajeDescuento: _porcentajeDescuento,
      arregloTratamientoPrecioVentaContado: _precioVentaContado,
    };
    setArregloTratamiento(_tratamiento);
  };
  //
  // ################################################################################
  //
  const handleLimpiarTratamiento = () => {
    setArregloTratamiento(initialArregloTratamiento);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Box sx={{ mx: 1, px: 1, pb: 1 }}>
        {gaAction.cu !== "view" && (
          <>
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  {/* tratamiento para ojo */}

                  <FormControl fullWidth disabled={disabledTratamientos} sx={{ mb: 1 }}>
                    <InputLabel id="ojo-select-label">Tratamiento para ojo ...</InputLabel>
                    <Select
                      labelId="ojo-select-label"
                      label="Tratamiento para ojo ..."
                      id="ojo-select"
                      name="arregloTratamientoOjo"
                      value={arregloTratamientoOjo}
                      size="small"
                      onChange={handleChangeArregloTratamiento}
                    >
                      {ojoValidOptions.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1}>
                <Grid item md={6}>
                  {/* codigo de tratamiento */}

                  <TextField
                    sx={{ mb: 1 }}
                    id="codigo-tratamiento"
                    label="Código del Tratamiento"
                    variant="outlined"
                    size="small"
                    name="arregloTratamientoCodigo"
                    value={arregloTratamientoCodigo}
                    onChange={handleChangeArregloTratamiento}
                    disabled={arregloTratamientoDescripcion !== "" || disabledTratamientos}
                  />
                </Grid>

                <Grid item md={6}>
                  {/* boton buscar */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    onClick={handleBuscarTratamiento}
                    startIcon={<SearchIcon />}
                    disabled={
                      arregloTratamientoCodigo === "" || arregloTratamientoDescripcion !== ""
                    }
                  >
                    Buscar
                  </Button>

                  {/* boton busqueda avanzada */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    onClick={handleClickOpenBusquedaAvanzada}
                    startIcon={<SavedSearchIcon />}
                    disabled={disabledTratamientos}
                  >
                    Búsqueda Avanzada
                  </Button>

                  {/* boton limpiar */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="outlined"
                    onClick={handleLimpiarTratamiento}
                    startIcon={<CleaningServicesIcon />}
                    disabled={arregloTratamientoCodigo === ""}
                  >
                    Limpiar
                  </Button>
                </Grid>
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={12} md={6} sx={{ mb: 1 }}>
                  {/* descripcion */}

                  <TextField
                    sx={{ width: "100%" }}
                    id="descripcion-tratamiento"
                    label="Descripción"
                    variant="outlined"
                    size="small"
                    name="arregloTratamientoDescripcion"
                    value={arregloTratamientoDescripcion}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  {/* precio de lista */}

                  <TextField
                    sx={{ width: "70%" }}
                    id="tratmientoPrecioVenta"
                    label="Precio de lista"
                    variant="outlined"
                    size="small"
                    name="arregloTratamientoPrecioVenta"
                    value={arregloTratamientoPrecioVenta.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  {/* precio de contado */}

                  <TextField
                    sx={{ width: "70%" }}
                    id="arregloTratamientoPrecioVentaContado"
                    label="Precio de contado"
                    variant="outlined"
                    size="small"
                    name="arregloTratamientoPrecioVentaContado"
                    value={arregloTratamientoPrecioVentaContado.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  {/* boton agregar */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    disabled={
                      disabledTratamientos ||
                      arregloTratamientoOjo === "" ||
                      arregloTratamientoCodigo === "" ||
                      arregloTratamientoDescripcion === ""
                    }
                    onClick={() => handleClickActionTratamiento()}
                    startIcon={<AddCircleOutlineOutlinedIcon />}
                  >
                    Agregar
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </>
        )}

        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
            <DataGrid
              rows={arregloTratamientosRows}
              columns={tableColumns}
              {...tableOptions}
            />
          </Grid>

          <Grid item sm={6}>
            <Typography
              component="div"
              align="right"
              sx={{
                p: 1,
                mt: 2,
                backgroundColor: "LightBlue",
                borderRadius: "5px",
                fontWeight: "bold",
              }}
            >
              PRECIO DE LISTA: {formatMoney(totalArregloTratamientos)}
            </Typography>
          </Grid>
          <Grid item sm={6}>
            <Typography
              component="div"
              align="right"
              sx={{
                p: 1,
                mt: 2,
                backgroundColor: "LightBlue",
                borderRadius: "5px",
                fontWeight: "bold",
              }}
            >
              PRECIO DE LISTA: {formatMoney(totalArregloTratamientosContado)}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {openDialogBusquedaAvanzada && (
        <BuscarTratamientoDialog
          open={openDialogBusquedaAvanzada}
          onClose={handleCloseBusquedaAvanzada}
          onSelect={handleSelectBusquedaAvanzada}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ArregloTratamientos;
